import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { RouteImage } from '../../../../assets/routeImage'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import Navbar from '../../Navbar'
import Header from '../../Header'
import { ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import * as styled from '../../style/main.style'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import ModalCustom from '../../../../component/modal/ModalCustom'
import AddFiscalYear from './add-fiscalyear/AddFiscalYear'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import Loading from '../../../../component/loading/Loading'
import EditFiscalYear from './edit-fiscalyear/EditFiscalYear'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

// STORE
import { useDispatch, useSelector } from 'react-redux'
import { changeIdFiscalYear } from '../../../../store/slice/fiscal-year/fiscalYear.slice'


// API
import { cloneFiscalYear, FiscalYearApi, getFiscalYear, updateFiscalYear } from '../../../../api/fiscal-year/fiscalyear.api';
import FilterSelect from '../../../../component/select/filterSelect'
import { alertActive, alertError, alertInput, alertSuccess } from '../../../../component/alert/swal'


type Props = {}
const FiscalYear: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [showModalAdd, setShowModalAdd] = useState<boolean>(false);
    const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
    const [fiscalYear, setFiscalYear] = useState<[]>([]);
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);

    const handleToggleAdd = () => setShowModalAdd(!showModalAdd)
    const handleToggleEdit = () => setShowModalEdit(!showModalEdit)

    // API
    const handleChangeStatus = async (idFiscalYear: number, fiscalYear: string, status: string) => {
        dispatch(setLoading())
        let condition: updateFiscalYear = {
            fiscalYear: fiscalYear,
            fiscalYearStatus: status
        }
        await FiscalYearApi.updateFiscalYear(idFiscalYear, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetFiscalYear())
    }
    const handleGetFiscalYear = useCallback(async () => {
        dispatch(setLoading())
        let condition: getFiscalYear = {
            page: page,
            limit: pageLimit
        }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setFiscalYear(res.data?.result?.items)
                    setTotalItems(res.data?.result?.meta?.totalItems)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit])


    const handleCloneFiscalYear = async (idFiscalYear: number, body: cloneFiscalYear) => {
        alertInput("ทำซ้ำปีงบประมาณ", `ท่านต้องการทำซ้ำปีงบประมาณ ${body.fiscalYear}?`, undefined, undefined, async (value) => {
            dispatch(setLoading())
            await FiscalYearApi.clone(idFiscalYear, { fiscalYear: `${value}`, fiscalYearStatus: body.fiscalYearStatus }).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ทำซ้ำปีงบประมาณ", "ทำซ้ำปีงบประมาณ เรียบร้อย");
                } else {
                    alertError("ทำซ้ำปีงบประมาณ", "ทำซ้ำปีงบประมาณ ไม่สำเร็จ");
                }
            }).catch((err) => {
                console.log(err)
                alertError("ทำซ้ำปีงบประมาณ", "ทำซ้ำปีงบประมาณ ไม่สำเร็จ");
            }).finally(() => {
                handleGetFiscalYear();
                dispatch(unsetLoading());
            })
        }, undefined, 'ปีงบประมาณ', 'เพื่อสร้างปีงบประมาณ', 4, 'ระบุปีงบประมาณที่ต้องการ', 'ปีงบประมาณควรมี 4 จำนวน')
    }

    const headCells = [
        {
            id: "FISCAL_YEAR", disablePadding: false, align: 'center', label:
                <HeaderTopicTable align='start' text='ปีงบประมาณ' />
        },
        {
            id: "STATUS", width: 100, disablePadding: false, align: "center", label:
                <HeaderTopicTable align='center' minWidth='130px' text='สถานะ' />
        },
        {
            id: "DATE", disablePadding: false, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idFiscalYear, fiscalYear, fiscalYearStatus } =
            objData;

        const objRenderData = {
            key: idFiscalYear,
            id: no,
            obj: objData,
            onClick: () => {
                // navigate(`/auth/setting/strategic/${idFiscalYear}`)
                // dispatch(changeIdFiscalYear(idFiscalYear))
            },
            columns: [
                { option: "TEXT", align: "left", label: fiscalYear },
                {
                    option: "TEXT", align: "left", label:
                        <FilterSelect
                            headingNormal
                            renderValue={() =>
                                <ListItemText className='relative text-center'>
                                    {fiscalYearStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }

                            label={t('STATUS.LABEL')}
                            selectId="select-status-year"
                            value={fiscalYearStatus}
                            labelId="label-status-year"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatus(idFiscalYear, fiscalYear, e.target.value)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 10,
                    component:
                        <div className='w-full min-w-[320px] flex justify-end gap-5'>
                            <Button
                                onClick={() => {
                                    dispatch(changeIdFiscalYear(idFiscalYear))
                                }}
                                sx={disableStyleButtonMui}>
                                <FilterSelect
                                    renderValue={() =>
                                        <div className='w-16 relative'>
                                            <RemoveRedEyeOutlinedIcon className='absolute left-[10px] top-1/2 translate-x-[-50%] translate-y-[-50%] ' />
                                            <Typography className='text-base'>{"ดู"}</Typography>
                                        </div>}
                                    label={t('STATUS.LABEL')}
                                    selectId="select-view"
                                    value={"-"}
                                    labelId="label-view"
                                    onchange={() => { }}
                                    options={[
                                        <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                            <button onClick={() => {
                                                navigate('/auth/setting/strategic')
                                            }}>
                                                {"ยุทธศาสตร์ / กลยุทธ์"}
                                            </button>
                                        </MenuItem>,
                                        <MenuItem key="2" value={t("STATUS.ACTIVE")}>
                                            <button onClick={() => {
                                                navigate('/auth/setting/mission-type')
                                            }}>
                                                {"ประเภทภารกิจ"}
                                            </button>
                                        </MenuItem>,
                                        <MenuItem key="2" value={t("STATUS.ACTIVE")}>
                                            <button onClick={() => {
                                                navigate('/auth/setting/project-progress')
                                            }}>
                                                {"ความคืบหน้าโครงการ"}
                                            </button>
                                        </MenuItem>,
                                        <MenuItem key="2" value={t("STATUS.ACTIVE")}>
                                            <button onClick={() => {
                                                navigate('/auth/setting/notification')
                                            }}>
                                                {"การแจ้งเตือนหน้าหลัก"}
                                            </button>
                                        </MenuItem>,
                                        <MenuItem key="2" value={t("STATUS.ACTIVE")}>
                                            <button onClick={() => {
                                                navigate('/auth/setting/project-type')
                                            }}>
                                                {"ประเภทโครงการ"}
                                            </button>
                                        </MenuItem>,
                                    ]}
                                />
                            </Button>
                            <Button
                                onClick={() => {
                                    handleToggleEdit()
                                    setIdFiscalYear(idFiscalYear)
                                }}
                                startIcon={<img src={RouteImage.editPen} />}
                                sx={disableStyleButtonMui}>{t("BUTTON.EDIT")}</Button>
                            <Button
                                onClick={() => handleCloneFiscalYear(idFiscalYear, {
                                    fiscalYear: fiscalYear,
                                    fiscalYearStatus: "เปิดใช้งาน"
                                })}
                                startIcon={<img src={RouteImage.copy} />}
                                sx={disableStyleButtonMui}>{"ทำซ้ำ"}</Button>
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetFiscalYear();
    }, [page, pageLimit])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            {showModalAdd && (
                <ModalCustom
                    maxHeight='auto'
                    enableExit={handleToggleAdd}
                    alignHeader='center'
                    heading='เพิ่มปีงบประมาณ'
                    component={<AddFiscalYear fetchData={handleGetFiscalYear} toggleModal={handleToggleAdd} />}
                />
            )}
            {showModalEdit && (
                <ModalCustom
                    maxHeight='auto'
                    enableExit={handleToggleEdit}
                    alignHeader='center'
                    heading='แก้ไขปีงบประมาณ'
                    component={<EditFiscalYear fiscalYearId={idFiscalYear} fetchData={handleGetFiscalYear} toggleModal={handleToggleEdit} />}
                />
            )}
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'>
                        <Typography className='text-primary' variant='h4'>
                            ปีงบประมาณ
                        </Typography>
                        <ButtonOutlined
                            onClick={handleToggleAdd}
                            sx={{ maxWidth: "75px" }}
                            startIcon={<img src={RouteImage.addButton} />} >
                            <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                        </ButtonOutlined>
                    </section>

                    <section className='mt-8 w-full h-auto'>
                        {fiscalYear && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={fiscalYear && fiscalYear.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default FiscalYear